import api from '@/services/Api';

import { RentalFile } from '@/models/rentalModule/RentalFile';
import { RentalFileSummary } from '@/models/rentalModule/RentalFileSummary';


class RentalFileService {
  async createRentalFile(data) {
    const response = await api.post(
      '/rental/distributor/rental-file/create',
      data)
    return response.data
  }

  async getRentalFileSummary(rentalFileId){
    const response = await api.get(
      '/rental/distributor/rental-file/summary-detail/' + rentalFileId)
    return new RentalFileSummary(
      response.data.rental_file_technical_id,
      response.data.rental_file_boomerang_id,
      response.data.rental_file_status,
      response.data.product_manufacturer_name_ref,
      response.data.store_name,
      response.data.client_name,
      response.data.client_company_name,
      response.data.send_date,
      response.data.requestor_full_name,
      response.data.repair_file_boomerang_id
    )
  }

  async getRentalFileDetail(rentalFileId) {
    const response = await api.get(
      '/rental/distributor/rental-file/detail/' + rentalFileId)
    return new RentalFile(
      response.data.rental_file_technical_id,
      response.data.rental_file_boomerang_id,
      response.data.product_picture,
      response.data.rental_file_opened_since_days,
      response.data.rental_file_status,
      response.data.product_manufacturer_name,
      response.data.product_manufacturer_name_ref,
      response.data.product_category,
      response.data.product_sub_category,
      response.data.product_name,
      response.data.product_serial_number,
      response.data.client_name,
      response.data.client_email,
      response.data.client_phone,
      response.data.rental_file_package_boomerang_id,
      response.data.rental_client_cost,
      response.data.rental_distributor_cost,
      response.data.rental_file_additional_cost_boomerang_id,
      response.data.rental_client_additional_days_cost,
      response.data.rental_distributor_additional_days_cost,
      response.data.rental_deposit,
      response.data.rental_deposit_type,
      response.data.rentalCreatedDate
    )
  }

  async getPaginatedRentalFileCommentList(rental_file_id, page, limit) {
    const url = '/rental/distributor/rental-file/comment/list/' +
      rental_file_id +
      '?page=' + page +
      '&limit=' + limit
    const response = await api.get(url)
    return response.data
  }

  async createRentalFileComment(data) {
    const response = await api.post(
      '/rental/distributor/rental-file/comment/create',
      data)
    return response.data
  }

  async getAttachmentFileList(rentalFileId) {
    const response = await api.get(
      '/rental/distributor/rental-file/attachment/list/' + rentalFileId)
    return response.data
  }

  async uploadAttachmentFile(data) {
    const response = await api.put(
      '/rental/distributor/rental-file/attachment/upload-additional-attachment',
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    return response.data
  }

  async getRentalFileByRepairFileId(repairFileId) {
    const response = await api.get(
      '/rental/distributor/rental-file/by-repair-file/' + repairFileId)
    return response.data
  }

  async getRentalFileDeliveryAddress(rentalFileId) {
    const response = await api.get('/rental/distributor/rental-file/detail/' + rentalFileId + '/delivery-address')
    return response.data
  }

  async getRentalFileDayCountSuppDate(rentalFileId) {
    const response = await api.get('rental/distributor/rental-file/detail/' + rentalFileId + '/day-supp-count-date')
    return response.data
  }

  async updateRentalFileStatusToClientInformed(rentalFileId,
                                               date,
                                               requestorCollaboratorId) {
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const day = date.getDate().toString().padStart(2, '0')
    let data = {
      rental_file_id: rentalFileId,
      real_date: `${year}-${month}-${day}`,
      requestor_collaborator_id: requestorCollaboratorId
    }

    const response = await api.put(
      'rental/distributor/rental-file/status-update/client-informed',
      data)
    return response.data
  }

  async updateRentalFileStatusToStoreReceipt(rentalFileId,
                                             date,
                                             qrCodeToken,
                                             forcePassStatus,
                                             requestorCollaboratorId) {
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const day = date.getDate().toString().padStart(2, '0')
    let data = {
      rental_file_id: rentalFileId,
      real_date: `${year}-${month}-${day}`,
      qr_code_token: qrCodeToken,
      force_pass_status: forcePassStatus,
      requestor_collaborator_id: requestorCollaboratorId
    }

    const response = await api.put(
      'rental/distributor/rental-file/status-update/store-receipt',
      data)
    return response.data
  }

  async getQRCodeToken(rentalFileId, requestor_collaborator_id) {
    const response = await api.get(
      'rental/distributor/rental-file/qr-code-token/' + rentalFileId
      + '?requestor_collaborator_id=' + requestor_collaborator_id)
    return response.data
  }

  async validateRentalFileQrCodeToken(token){
    const data = {
      qr_code_token: token
    }
    const response = await api.post(
      'rental/distributor/rental-file/qr-code-token/validation', data)

    return response.data
  }

  async sendPictureWithQrCodeToken(data) {
    const response = await api.put(
      '/rental/distributor/rental-file/send-picture-with-qr-code',
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    return response.data
  }

  async updateRentalFileStatus(rentalFileId, date, requestorCollaboratorId) {
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const day = date.getDate().toString().padStart(2, '0')
    let data = {
      rental_file_id: rentalFileId,
      real_date: `${year}-${month}-${day}`,
      requestor_collaborator_id: requestorCollaboratorId
    }

    const response = await api.put(
      'rental/distributor/rental-file/status-update',
      data)
    return response.data
  }
}

export default new RentalFileService()
